import { defineMessages } from '@kyruus/intl';

export const messages = defineMessages({
  availabilityDisclaimer: {
    id: 'providerlist.footer.disclaimertext',
    description:
      "Disclaimer text stating that providers' availability is subject to change",
    defaultMessage: 'Appointment availability is subject to change'
  },
  psrDisclaimer: {
    id: 'providerlist.footer.psrdisclaimertext',
    description:
      'Disclaimer text stating that the search results are based on refined patient search results',
    defaultMessage:
      'Search results have been filtered based on your responses. You can view all providers by removing these filters. Provider selection and treatment decisions should be made in consultation with qualified healthcare professionals.'
  }
});
